/* 🤖 this file was generated by svg-to-ts */
export const matIconCrop169: {
  name: 'crop-16-9';
  data: string;
} = {
  name: 'crop-16-9',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z"/></svg>`
};
